<ng-template #template>
  <div class="col-12" [hidden]="hidden">
    <div
      class="card"
      [ngStyle]="
        isWhite
          ? { 'background-color': '#FFFFFF' }
          : { 'background-color': '#0E0E29' }
      "
    >
      <div class="card-body">
        <h3 [ngStyle]="isWhite ? { color: '#0E0E29' } : { color: '#FFFFFF' }">
          {{ data?.title }}
        </h3>
        <div style="display: block">
          <canvas
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [legend]="barChartLegend"
            [colors]="lineChartColors"
            [chartType]="barChartType"
          >
          </canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
